import { useEffect, useRef, useState } from 'react';
import { Labels } from '../labels';

const STORAGE_KEY = 'ep_cookie_accepted';
const COOKIE_POLICY_URL = 'https://fanatee.com/cookies';
const FADE_OUT_MS = 300;

function isAccepted() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

function setAccepted() {
  try {
    window.localStorage.setItem(STORAGE_KEY, 'true');
  } catch (e) {
  }
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);
  const [height, setHeight] = useState(0);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!isAccepted())
      setVisible(true);
  }, []);

  useEffect(() => {
    if (!closing)
      return;

    const timer = setTimeout(() => setVisible(false), FADE_OUT_MS);
    return () => clearTimeout(timer);
  }, [closing]);

  // A barra e fixa, entao reservamos a altura dela no fluxo da pagina para
  // que o rodape (e os links de politica) nao fiquem cobertos.
  useEffect(() => {
    const box = boxRef.current;

    if (!box)
      return;

    const update = () => setHeight(box.offsetHeight);

    update();

    const observer = new ResizeObserver(update);
    observer.observe(box);

    return () => observer.disconnect();
  }, [visible]);

  if (!visible)
    return null;

  const accept = () => {
    setAccepted();
    setClosing(true);
  };

  return (
    <>
      <div className={`cookie-box-spacer${closing ? ' cookie-box-spacer-closing' : ''}`}
        style={{ height: closing ? 0 : height }} />

      <div ref={boxRef} className={`cookie-box${closing ? ' cookie-box-hidden' : ''}`}>
        <div className='cookie-box-container'>
          <div className='cookie-box-content'>

            <div className='cookie-box-content-left'>
              <h2 className='cookie-box-title'>{Labels.CookieTitle.getValue()}</h2>
              <div className='cookie-box-text'>{Labels.CookieText.getValue()}</div>
            </div>

            <div className='cookie-box-content-right'>
              <a className='cookie-box-link' href={COOKIE_POLICY_URL}
                target='_blank' rel='noreferrer'>
                {Labels.CookieLearnMore.getValue()}
              </a>

              <button type='button' className='cookie-box-button' onClick={accept}>
                {Labels.CookieAccept.getValue()}
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
